import { makeAutoObservable } from 'mobx';
import apolloClient from 'api/apolloClient';
import { GET_EXCHANGE_READY_FILES } from 'api/pdfService';
import { IdsFileLocation } from 'types/pdfService';

export class PdfStore {
  // eslint-disable-next-line class-methods-use-this
  async getExchangeReadyFiles(sponsorId: string, setAsSent?: boolean): Promise<IdsFileLocation[]> {
    const res = await apolloClient.query<{ getExchangeReadyFiles: IdsFileLocation[] }>({
      query: GET_EXCHANGE_READY_FILES,
      fetchPolicy: 'no-cache',
      variables: { domainId: sponsorId, setAsSent },
    });
    return res.data.getExchangeReadyFiles;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
